var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _rect4, _rect5, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 89,
    viewBox: "0 0 126 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 47,
    width: 98,
    height: 42,
    rx: 8,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 47,
    width: 98,
    height: 42,
    rx: 8,
    fill: "url(#paint0_linear)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 47,
    width: 98,
    height: 42,
    rx: 8,
    fill: "#6C738A",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7192 67.9703C46.0996 67.9703 49.6507 64.4302 49.6507 60.0632C49.6507 55.6962 46.0996 52.1561 41.7192 52.1561C37.3387 52.1561 33.7877 55.6962 33.7877 60.0632C33.7877 64.4302 37.3387 67.9703 41.7192 67.9703Z",
    fill: "#F8FAFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.171 60.0625H57.5817C56.1218 60.0625 54.9379 58.8822 54.9379 57.4268C54.9379 55.9714 56.1218 54.7911 57.5817 54.7911H105.171C106.631 54.7911 107.815 55.9714 107.815 57.4268C107.815 58.8822 106.631 60.0625 105.171 60.0625Z",
    fill: "#F8FAFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.746 70.6053H57.5817C56.1218 70.6053 54.9379 69.425 54.9379 67.9696C54.9379 66.5141 56.1218 65.3339 57.5817 65.3339H115.746C117.206 65.3339 118.39 66.5141 118.39 67.9696C118.39 69.425 117.206 70.6053 115.746 70.6053Z",
    fill: "#F8FAFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9515 81.148H57.5817C56.1218 81.148 54.9379 79.9677 54.9379 78.5123C54.9379 77.0568 56.1218 75.8766 57.5817 75.8766H91.9515C93.4115 75.8766 94.5954 77.0568 94.5954 78.5123C94.5954 79.9677 93.4115 81.148 91.9515 81.148Z",
    fill: "#F8FAFE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 98,
    height: 42,
    rx: 8,
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 98,
    height: 42,
    rx: 8,
    fill: "url(#paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7192 20.9703C19.0996 20.9703 22.6507 17.4302 22.6507 13.0632C22.6507 8.69624 19.0996 5.15613 14.7192 5.15613C10.3387 5.15613 6.78766 8.69624 6.78766 13.0632C6.78766 17.4302 10.3387 20.9703 14.7192 20.9703Z",
    fill: "#F8FAFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1707 13.0625H30.5817C29.1218 13.0625 27.9379 11.8822 27.9379 10.4268C27.9379 8.9714 29.1218 7.79114 30.5817 7.79114H78.1707C79.6306 7.79114 80.8146 8.9714 80.8146 10.4268C80.8146 11.8822 79.6306 13.0625 78.1707 13.0625Z",
    fill: "#F8FAFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7461 23.6053H30.5817C29.1218 23.6053 27.9379 22.425 27.9379 20.9696C27.9379 19.5141 29.1218 18.3339 30.5817 18.3339H88.7461C90.206 18.3339 91.3899 19.5141 91.3899 20.9696C91.3899 22.425 90.206 23.6053 88.7461 23.6053Z",
    fill: "#F8FAFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9515 34.148H30.5817C29.1218 34.148 27.9379 32.9677 27.9379 31.5123C27.9379 30.0568 29.1218 28.8766 30.5817 28.8766H64.9515C66.4115 28.8766 67.5954 30.0568 67.5954 31.5123C67.5954 32.9677 66.4115 34.148 64.9515 34.148Z",
    fill: "#F8FAFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 27.5,
    y1: 70.5194,
    x2: 127.376,
    y2: 70.5194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEDF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 0.5,
    y1: 23.5194,
    x2: 100.376,
    y2: 23.5194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEDF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTable);
export default __webpack_public_path__ + "2b5a36d9fa7e03fd5eeb8cec36c5d450.svg";
export { ForwardRef as ReactComponent };